import { ROUTES } from "./routesPaths";

// 🔍 Extract route parameters from a pattern like /editstaffdocuments/:adminDocId
type ExtractRouteParams<T extends string> =
  T extends `${string}:${infer Param}/${infer Rest}`
    ? { [K in Param extends `${infer P}?` ? P : Param | keyof ExtractRouteParams<Rest>]: string }
    : T extends `${string}:${infer Param}`
    ? { [K in Param extends `${infer P}?` ? P : Param]: string }
    : Record<string, never>;

export function buildRoute<T extends ROUTES>(
  route: T,
  params?: ExtractRouteParams<T>
): string {
  let path = route as string;
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      path = path.replace(`:${key}`, value);
    }
  }
  return path;
}
